<template>
  <div class="container">
    <h1>
      Characters
      <span class="subheader" v-if="showSlots">
        (<span :class="{ red: !canAdd }">{{ items.length }}</span>/{{ freeLimit }})
      </span>
    </h1>
    <hr />
    <patreon v-if="!canAdd"></patreon>
    <div class="card-columns">
      <div v-if="canAdd" class="card" @click="$router.push({ path: `/characters/new` })">
        <div class="card-body">
          <h1 class="card-new">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
          </h1>
        </div>
      </div>

      <card v-for="item in items" :item="item" :isAdmin="isAdmin" :key="item._id"></card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Card from "./_Card";
import Patreon from "./_Patreon";

export default {
  name: "character-index",
  components: {
    Card,
    Patreon
  },
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
  },
  data() {
    return {
      freeLimit: process.env.VUE_APP_FREE_CHARACTER_LIMIT,
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin",
      isSupporter: "isSupporter",
      items: "characters/getEntities"
    }),
    ...mapState({
      items2: state => state.characters.all,
      ruleset: state => state.session.user.settings.ruleset
    }),
    showSlots() {
      return !this.isAdmin && !this.isSupporter;
    },
    canAdd() {
      return this.items.length < this.freeLimit || this.isAdmin || this.isSupporter;
    }
  },
  methods: {
    ...mapActions({
      charactersAll: "characters/all",
    }),
    async getData() {
      try {
        this.charactersAll({ params: `ruleset=${this.ruleset}&sort=name` });
        this.$embers.pageData("Characters");
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style>
  .red {
    color: #ff5800;
  }
</style>